"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderTest = void 0;
require("../../../../TdWebtoolkitControls/controls/Chart/Chart");
require("./synChart_tests.tmpl.less");
let markup = require("./synChart_tests.tmpl.htm");
function renderTest() {
    let that = this;
    let $contentPane = $("#testContentPane");
    $contentPane.html(markup);
    let $chartDashboard = $("#chartDashboard");
    $("#testChart1").synChart("75|154222|8000");
    /*$("#testChart2").synChart({
        ChartId: "75|154222|8000",
    });*/
}
exports.renderTest = renderTest;
